import { IMutationProps } from '../../../interfaces/ui';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';
import { ICreateCaseConversationSchedule } from '../../../interfaces/conversationSchedules';
import { createCaseConversationSchedule } from '../../conversationSchedules';
import {
  displayErrorArrayNotificationsWithoutTranslations,
  displayErrorNotification,
  displaySuccessNotification,
} from '../../../modules/Notifications';
import { IErrorDefinition } from '../../../interfaces/response';

type useCreateCaseConversationScheduleParams = {
  organizationId: string;
  caseId: string;
};

const useCreateCaseConversationSchedule = (
  params: useCreateCaseConversationScheduleParams,
  options: IMutationProps
) => {
  return useMutationWithResultNotification({
    asyncApiFunction: async (data: ICreateCaseConversationSchedule) => {
      await createCaseConversationSchedule(
        params.organizationId,
        params.caseId,
        data
      );
    },
    onSuccess: () => {
      displaySuccessNotification(
        'Api.Mutations.ConversationSchedules.CreateCaseConversationSchedule.success'
      );

      if (options.successFb) options.successFb();
    },
    onErrorArray: (errors: IErrorDefinition[]) => {
      displayErrorNotification(
        'Api.Mutations.ConversationSchedules.CreateCaseConversationSchedule.failure'
      );

      displayErrorArrayNotificationsWithoutTranslations(errors);

      if (options.errorFb) options.errorFb();
    },
    resetOnResult: true,
  });
};

export default useCreateCaseConversationSchedule;
